import Vue from 'vue';
import Vuex from 'vuex';
import VueJsonp from 'vue-jsonp'

Vue.use(Vuex);
Vue.use(VueJsonp);

export default new Vuex.Store({

    state:{
        categoryKey: 'recommend',
        categories:[
            {
                name:'推荐',
                key:'recommend'
            },
            {
                name:'社会',
                key:'society'
            },
            {
                name:'娱乐',
                key:'recreation'
            },
            {
                name:'军事',
                key:'military'
            },
            {
                name:'体育',
                key:'sports'
            }
        ],
        bannerData:[],
        newsList:[],
        moreList:[]
    },
    getters: {
        categoryKey(state) {
            return state.categoryKey;
        },
        categories(state) {
            return state.categories;
        },
        bannerData(state) {
            return state.bannerData;
        },
        newsList(state){
            return state.newsList;
        },
        moreList(state) {
            return state.moreList;
        }
    },
    mutations:{
        updateBannerData(state, data) {
            state.bannerData = data;
        },
        updateNewsList(state, data){
            state.newsList = data;
        },
        updateMoreList(state,data){
            state.moreList = state.moreList.concat(data);
        }
    },
    actions:{
        // 获取banner、新闻列表的数据；
        getTopList(store) {
            Vue.jsonp('http://3g.163.com/touch/jsonp/sy/recommend/0-9.html').then( data => {
                //console.log(data);
                if (data.code == 200) {
                    //console.log(data);
                    let bannerData = data.focus.filter( item => {
                        return item.addata == null;
                    }).map( item => {
                        return {
                            title: item.title,
                            img: item.picInfo[0].url,
                            url: item.link
                        }
                    });

                    let newsList = data.list.filter( item => {
                        return item.addata == null;
                    }).map( item => {
                        return {
                            title: item.title,
                            src: item.picInfo[0].url,
                            url: item.link,
                            desc: item.source
                        }
                    });

                    store.commit('updateBannerData', bannerData);
                    store.commit('updateNewsList',newsList);
                }
            });
        },

        // 下拉刷新数据；
        refreshNewList(store, {refreshKey}){
            return Vue.jsonp('http://3g.163.com/touch/jsonp/sy/recommend/0-9.html', {
                miss: '00',
                refresh: refreshKey
            })
                .then( data => {
                    let newList = data.list.filter( item =>{
                        return item.addate == null;
                    } ).map( item => {
                        return {
                            title: item.title,
                            src: item.picInfo[0].url,
                            url: item.link,
                            desc: item.source
                        }
                    });

                    store.commit('updateNewsList', newList);
                    return Promise.resolve(newList.length);
                })
        },

        // 上拉加载数据；
        loadMoreList(store,{refreshKey,page,prepage}){
            let start = page * prepage;
            let end = start + prepage;
            return Vue.jsonp(`http://3g.163.com/touch/jsonp/sy/recommend/${start}-${end}.html`,{
                miss: '00',
                refresh: refreshKey
            })
                .then( data => {
                    let moreList = data.list.filter( item => {
                        return item.addata == null && item.picInfo.length;
                    }).map( item => {
                        return {
                            title: item.title,
                            src: item.picInfo[0].url,
                            url: item.link,
                            desc: item.source
                        }
                    })

                    store.commit('updateMoreList',moreList);
                    return Promise.resolve();
                })

        }


    }

});



// WEBPACK FOOTER //
// ./src/store/index.js